import React, { useCallback, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { assignEmailThreadAgent } from "redux/slices/central-email-threads";
import { getSupportAgents } from "redux/slices/support-agents";
import {
  findSupportAgent,
  sortSupportAgentsByName,
  supportAgentLabel,
  supportAgentName,
} from "helpers/support-agent-name";

const UNASSIGNED = "";

const ThreadAssignee = ({ threadId, supportAgentId }) => {
  const dispatch = useDispatch();
  const supportAgents = useSelector(getSupportAgents);
  const sortedSupportAgents = useMemo(
    () => sortSupportAgentsByName(supportAgents),
    [supportAgents]
  );

  const [isSaving, setIsSaving] = useState(false);

  const isAssigned = supportAgentId !== null && supportAgentId !== undefined;
  const value = isAssigned ? String(supportAgentId) : UNASSIGNED;

  // An assignee can drop out of the agent list (an admin who has since left),
  // and a select whose value matches no option silently shows the first one,
  // which would read as unassigned.
  const isListed = !isAssigned || !!findSupportAgent(supportAgents, value);

  const onChange = useCallback(
    async (event) => {
      const next = event.target.value;

      setIsSaving(true);
      await dispatch(
        assignEmailThreadAgent({
          id: threadId,
          supportAgentId: next === UNASSIGNED ? null : next,
        })
      );
      setIsSaving(false);
    },
    [dispatch, threadId]
  );

  return (
    <label className="inboxAssignee">
      <span className="inboxAssigneeLabel">Assignee</span>
      <select
        className="inboxSelect"
        value={value}
        onChange={onChange}
        disabled={isSaving}
      >
        <option value={UNASSIGNED} aria-label="Unassigned" />
        {!isListed && (
          <option value={value}>{supportAgentLabel(undefined, value)}</option>
        )}
        {sortedSupportAgents.map((agent) => (
          <option key={agent.id} value={String(agent.id)}>
            {supportAgentName(agent)}
          </option>
        ))}
      </select>
    </label>
  );
};

export default ThreadAssignee;
